import type { CandleWithFlag } from "../model/types";

export function createLiveCandle(
  bucket: number,
  open: number,
  high: number,
  low: number,
  close: number,
): CandleWithFlag {
  return {
    timestamp: new Date(bucket).toISOString(),
    open,
    high,
    low,
    close,
    price: close,
    isNew: true,
    isAnimating: false,
  };
}
